
import Vue from "vue"
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class AnalyticsDataSource extends Vue {
    selectedActivities: Array<any> = []
    selectedMilestones: Array<any> = []
    dashboardColor = { hex: '' }
    chartColor = { hex: '' }
    textColor = { hex: '#000' }
    fontSize = '12'
    fontWeight = '400'
    filteredProjects: Array<any> = []
    selectedLeaseId: string = 'all'
    filterOptions: Array<any> = []

    // Emit the on-styles-changed event with the current style properties
    emitStylesChanged() {
        this.$emit('on-styles-changed', {
            dashboardColor: this.dashboardColor.hex,
            textColor: this.textColor.hex,
            chartBackground: this.chartColor.hex,
            fontSize: +this.fontSize,
            fontWeight: this.fontWeight
        });
    }

    // Watch each style property and emit on-styles-changed when any of them changes
    @Watch('dashboardColor', { deep: true })
    onDashboardColorChanged() {
        this.emitStylesChanged();
    }

    @Watch('textColor', { deep: true })
    onTextColorChanged() {
        this.emitStylesChanged();
    }

    @Watch('chartColor', { deep: true })
    onChartColorChanged() {
        this.emitStylesChanged();
    }

    @Watch('fontSize')
    onFontSizeChanged() {
        this.emitStylesChanged();
    }

    @Watch('fontWeight')
    onFontWeightChanged() {
        this.emitStylesChanged();
    }

    @Watch('selectedProjects')
    onSelectedProjectsChanged() {
        this.$emit('on-selected-project-changed', this.selectedProjects.length ? this.selectedProjects[0] : null);
    }

    @Watch('projects')
    onProjectsLoaded(){
        if (this.projects.length){
            this.filterOptions = this.leaseId
        }else{
            this.filterOptions = []
        }
    }

    @Watch('selectedLeaseId')
    onSelectedLeaseIdChanged() {
        this.filterByLeaseId()
    }
    
    get sortedProjects(): Array<any> {
        if (this.filteredProjects && this.filteredProjects.length){
            return this.filteredProjects.slice().sort((a, b) => a.name.localeCompare(b.name))
        }
        if (this.projects && this.projects.length) return this.projects.slice().sort((a, b) => a.name.localeCompare(b.name));
        return []
    }

    get sequences(): Array<any> {
        return this.$store.getters["sequencesModule/getSequences"]
    }

    get sequenceOptions(): Array<any> {
        if (this.sequences) return this.sequences.map((s: any) => ({ value: s.id, text: s.name }))
        return []
    }

    get projects(): Array<any> {
        if (!this.selectedSequence) return []
        let projects = this.$store.getters["projectModule/getProjectsForSequence"](this.selectedSequence)
        if (projects.length < 1) {
            this.$store.dispatch("projectModule/getProjectsForSequence", this.selectedSequence)
            return []
        }
        return projects
    }

    get activeAnalyticsElement() {
        return this.$store.state.Analytics.activeAnalyticsElements
    }

    get selectedProjects(): Array<any> {
        return this.$store.state.Analytics.selectedProjects
    }

    set selectedProjects(value) {
        this.$store.commit("Analytics/updatedSelectedProjects", value)
    }

    get selectedSequence(): any {
        return this.$store.state.Analytics.selectedSequence
    }

    set selectedSequence(value) {
        this.$store.commit("Analytics/updateSelectedSequence", value)
    }

    filterByLeaseId () {
        this.filteredProjects = this.projects.filter(project => {
            if (project.well && project.well !== null){
                return String(project.well.leaseId).toLowerCase() === this.selectedLeaseId.toLowerCase()
            }
        })
    }

    handleProjectSelection(selectedId: string) {
        if (this.selectedProjects.includes(selectedId)) {
            // Ensure only the newly selected project remains
            this.selectedProjects = [selectedId];
        } else {
            this.selectedProjects = [selectedId];
        }
    }

    get leaseId() : Array<any> {
        return Array.from(new Set(this.projects.map((project: any ) => project.well.leaseId)))
    }

    get getWellsAction () {
        return this.$store.dispatch('wellsModule/getWellsAction')
    }

    sequenceSelectionChanged() {
        this.selectedProjects = []
        this.filteredProjects = []
        this.selectedLeaseId = 'all'
    }

    closePropertyGrid() {
        this.$store.commit("setRightPaneToFalse")
    }

    changeBack() {
        let back = this.dashboardColor as any
        this.$store.commit('Analytics/updatedBackgroundColor', back.hex)
    }

    mounted() {
        if (!this.sequences || this.sequences.length < 1) this.$store.dispatch("sequencesModule/fetchSequences")
    }
}
